export default {
  methods: {
    toggleModal(name) {
      const $body = document.querySelector('body');
      let scrollPosition;
      if (this[name] === false) {
        scrollPosition = window.pageYOffset;
        this[name] = true;
        document.body.classList.add('has-open-modal');
        $body.style.top = `-${scrollPosition}px`;
      } else {
        this[name] = false;
        document.body.classList.remove('has-open-modal');
        scrollPosition = Math.abs(parseFloat($body.style.top));
        $body.style.removeProperty('top');
        window.scrollTo(0, scrollPosition);
      }
    }
  }
};
